<template>
  <div id="MasterUser">
    <BaseTitle :title="$t('menu.user_lite')" />
    <v-card class="mb-7">
      <div class="pa-5">
        <h3>Filter</h3>
        <v-row>
          <v-col cols="12" md="4">
            <v-select
              :items="schoolList"
              item-value="masterSchoolId"
              item-text="schoolName"
              :label="$t('form.school_name')"
              v-model="form.masterSchoolId"
              clearable
              @change="getFilter"
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              :items="roleWithoutSchooladmin"
              item-value="roleId"
              item-text="roleName"
              :label="$t('table.role')"
              v-model="form.roleId"
              clearable
              @change="getFilter"
            >
            </v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-select :items="status" :label="$t('form.status')" v-model="form.status" clearable @change="getFilter">
              <template #item="{item}">
                {{ $t(item.text) }}
              </template>
              <template #selection="{item}">
                {{ $t(item.text) }}
              </template>
            </v-select>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.user_list') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @change="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div v-for="item in listData" :key="item.userId" class="border-item">
          <v-row class="border-item">
            <v-col md="1" align="center">
              <div class="mt-5 ml-5">
                <svg-icon icon="customer-plus" width="30" height="30" class="primary--text" />
                <v-divider vertical></v-divider>
              </div>
            </v-col>
            <v-col :md="item.storage ? 8 : 10" class="mt-3">
              <div class="d-block">
                <h3 class="d-inline">
                  <span class="header-content">{{ item.fullName }} </span>
                </h3>
              </div>
              <div class="d-block">
                <div>
                  <span class="mr-3">
                    {{ $t('form.status') }}:
                    <strong v-if="item.status" class="green--text font-italic header-content">{{ $t('form.active') }}</strong>
                    <strong v-else class="red--text font-italic header-content">{{ $t('form.noactive') }}</strong>
                  </span>
                  |
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('table.role') }}:
                      <strong v-if="item.role">{{ item.role }}</strong>
                      <strong v-else>-</strong>
                    </span>
                  </span>
                  |
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('form.school_name') }}:
                      <strong v-if="item.schoolName">{{ item.schoolName }}</strong>
                      <strong v-else>-</strong>
                    </span>
                  </span>
                  |
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('content.register') }}:
                      <strong v-if="item.registerAt">{{ item.registerAt }}</strong>
                      <strong v-else>-</strong>
                    </span>
                  </span>
                  |
                  <span class="body-content">
                    <span class="mr-3">
                      {{ $t('content.last_activity') }}:
                      <strong v-if="item.lastActivity > 0">{{ item.lastActivity }} {{ $t('content.day_ago') }}</strong>
                      <strong v-if="item.lastActivity === '0'">{{ $t('content.today') }}</strong>
                      <strong v-if="item.lastActivity === '-'">{{ $t('content.not_login') }}</strong>
                    </span>
                  </span>
                </div>
              </div>
              <div class="d-flex"></div>
            </v-col>
            <v-col v-if="item.storage" md="2" class="mt-6">
              <v-row no-gutters>
                <v-col md="12" class="d-flex justify-space-between">
                  <span class="body-content"
                    >{{ item.storage ? item.storage.storageUsed : 0 }} MB of {{ item.storage ? item.storage.totalStorage : 0 }} MB used</span
                  >
                </v-col>
              </v-row>
              <v-row class="mb-6" no-gutters>
                <v-col md="12">
                  <v-progress-linear
                    :color="'#00BF63'"
                    height="14"
                    background-color="#E3E3E3"
                    :value="item.storage ? item.storage.percentage : 0"
                    style="border-radius: 9px;"
                  >
                  </v-progress-linear>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="1">
              <template>
                <div class="pa-5">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <span dark v-bind="attrs" v-on="on">
                        <svg-icon icon="ic-moreaction-black" class="mt-1" />
                      </span>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title class="text-dropdown" @click="viewItem(item)">{{ $t('view') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title class="text-dropdown" @click="editItem(item)">{{ $t('edit') }}</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="!item.primarySchoolAdmin && !item.primaryMasterAdmin && item.userId !== currentUser.userId">
                        <v-list-item-title class="text-dropdown-delete" @click="onDeleteItem(item)">{{ $t('table.delete') }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </template>
            </v-col>
          </v-row>
        </div>
        <NoData v-if="!listData.length" />
      </div>
    </v-card>

    <!-- Dialog Generate -->
    <v-dialog v-model="dialogGenerate" persistent max-width="340">
      <v-card>
        <v-card-title class="headline">{{ $t('generate_title') }}</v-card-title>
        <v-card-text>{{ $t('generate_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :loading="table.loading" @click="dialogGenerate = false">{{ $t('disagree') }}</v-btn>
          <v-btn text @click="generatePasswordItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog Delete -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
          <v-btn text :loading="table.loading" @click="deleteItem">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';

export default {
  name: 'MasterUserLite',
  components: {
    BaseTitle,
    NoData
  },
  computed: {
    ...mapGetters({
      currentUser: 'Auth/user',
      status: 'Reference/itemStatus',
      role: 'Role/items'
    }),
    roleWithoutSchooladmin() {
      return this.role.filter(role => role.roleId !== 3 && role.roleId !== 2 && role.roleId !== 1 && role.roleId !== 6);
    }
  },
  data: () => ({
    dialogGenerate: false,
    generatePwItem: null,
    dialogDelete: false,
    currentItem: null,
    listData: [],
    schoolList: [],
    search: '',
    loadingLoad: false,
    form: {
      status: '',
      roleId: '',
      masterSchoolId: ''
    },
    table: {
      loading: false,
      options: {}
    }
  }),
  watch: {
    'table.options': function() {
      this.getData();
    }
  },
  methods: {
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('UserLite/fetchList', {
          search: this.search
        })
        .then(data => (this.listData = data))
        .finally(() => (this.loadingLoad = false));
    },
    getDataSchool() {
      this.loadingLoad = true;
      this.$store
        .dispatch('UserLite/fetchSchool')
        .then(data => (this.schoolList = data))
        .finally(() => (this.loadingLoad = false));
    },
    getFilter() {
      if (
        (this.form.status !== '' && typeof this.form.status != 'undefined') ||
        this.form.roleId ||
        (this.form.masterSchoolId && this.form.roleId && this.form.status !== '' && typeof this.form.status != 'undefined') ||
        this.form.masterSchoolId
      ) {
        this.loadingLoad = true;
        this.$store
          .dispatch('UserLite/fetchFilter', {
            status: this.form.status,
            roleId: this.form.roleId,
            masterSchoolId: this.form.masterSchoolId
          })
          .then(data => (this.listData = data))
          .finally(() => (this.loadingLoad = false));
      } else {
        this.getData();
      }
    },
    editItem({ userId }) {
      this.$router.push({ name: 'MasterUserLiteEdit', params: { id: userId } });
    },
    viewItem({ userId }) {
      this.$router.push({ name: 'MasterUserLiteDetail', params: { id: userId } });
    },
    onDeleteItem(item) {
      this.dialogDelete = true;
      this.currentItem = item;
    },
    deleteItem() {
      if (!this.currentItem) return false;

      this.table.loading = true;
      this.$store
        .dispatch('UserLite/destroy', this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.table.loading = false));
    },
    getRole() {
      this.$store.dispatch('Role/fetchList');
    },
    onGenerateItem(item) {
      this.generatePwItem = item;
      this.dialogGenerate = true;
    },
    generatePasswordItem() {
      if (!this.generatePwItem) return false;
      this.table.loading = true;
      this.$store
        .dispatch('User/generatePassword', this.generatePwItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.generatePwItem = null;
          this.getData();
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.table.loading = false));
      this.dialogGenerate = false;
    },
    goToCreate() {
      this.$router.push({ name: 'MasterUserCreate' });
    }
  },
  created() {
    this.$store.commit('table/RESET_PAGEABLE');
    this.getRole();
    this.getData();
    this.getDataSchool();
  },
  submit() {
    this.$v.$touch();
    if (this.$v.$invalid) {
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
